<script lang="ts">
  import { domId } from "../../../lib/dom";
  import SharepointFileInput from "../../../components/SharepointFileInput.svelte";
  import { type Component } from "svelte";

  let {
    answer,
    back,
    inactive,
    clientName,
    financeAgreementStartDateLocalized,
    createUploadSessionUrl,
    clientNameUploadAllowedExtensions,
    nextStep,
  }: {
    answer: ({ nextStep }) => void;
    back: () => void;
    inactive: boolean;
    clientName: { [key: string]: string };
    financeAgreementStartDateLocalized: string;
    createUploadSessionUrl: string;
    clientNameUploadAllowedExtensions: string[];
    nextStep: Component;
  } = $props();

  let fileInput = $state<SharepointFileInput>();
  let firstNameInput = $state(clientName.firstName);
  let lastNameInput = $state(clientName.lastName);
  let errors = $state([]);

  function handleBack() {
    fileInput?.cancelAll();
    back();
  }

  function handleContinue() {
    confirmNameInput();
    if (errors.length === 0 && allowContinue()) {
      answer({ nextStep });
    }
  }

  function allowContinue() {
    if (fileInput?.hasFiles) {
      return fileInput?.uploadComplete();
    }

    return true;
  }

  function confirmNameInput() {
    errors = [];
    if (firstNameInput === "") {
      errors.push("First name is required");
    }
    if (lastNameInput === "") {
      errors.push("Last name is required");
    }
    if (
      clientName.firstName === firstNameInput &&
      clientName.lastName === lastNameInput
    ) {
      errors.push(
        "Please enter a different name from the original one you provided",
      );
    }
  }

  $effect(() => {
    allowContinue();
  });

  const firstNameId = domId("first-name");
  const lastNameId = domId("last-name");
</script>

<div class="h-full">
  <fieldset class="ui-fieldset">
    <legend>
      <span>
        What name did you use to purchase this vehicle on <b>{financeAgreementStartDateLocalized}</b>?
      </span>
    </legend>

    <fieldset class="ui-fieldset">
      <legend>First name</legend>
      <input
        id={firstNameId}
        type="text"
        name="client_name[first_name]"
        class="ui-input"
        bind:value={firstNameInput}
        required
      />
    </fieldset>
  
    <fieldset class="ui-fieldset">
      <legend>Last name</legend>
      <input
        id={lastNameId}
        type="text"
        name="client_name[last_name]"
        class="ui-input"
        bind:value={lastNameInput}
        required
      />
    </fieldset>

    {#if errors.length > 0}
      <div class="ui-error">{errors.join(". ")}</div>
    {/if}
  </fieldset>

  <fieldset class="ui-fieldset">
    <legend>Upload a document with your previous name (optional)</legend>
    <SharepointFileInput
      bind:this={fileInput}
      name={"client_name_document"}
      {createUploadSessionUrl}
      accept={clientNameUploadAllowedExtensions}
    />
  </fieldset>
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button
    type="submit"
    class="btn btn-primary"
    onclick={handleContinue}
    disabled={!allowContinue() || inactive}>Continue</button
  >
</div>
